export const PLATFORMS = [
  { key: "core", label: "Main PBX" },
  { key: "sas", label: "SAS" },
  { key: "hospitality", label: "Hospitality" },
];
export const PLATFORM_LABEL = Object.fromEntries(PLATFORMS.map((p) => [p.key, p.label]));

export const KINDS = [
  { key: "add", label: "Would be added", hint: "next nightly run" },
  { key: "move", label: "Would be moved", hint: "wrong subscription or product" },
  { key: "remove", label: "Would be removed", hint: "month-end run" },
  { key: "create_subscription", label: "New subscriptions", hint: "domains without one" },
  { key: "issue", label: "Problems", hint: "the scripts would e-mail these" },
];

export const TONE = {
  add: { text: "text-emerald-700", soft: "bg-emerald-50 border-emerald-200 text-emerald-800", dot: "bg-emerald-500", ring: "ring-emerald-300 border-emerald-400" },
  move: { text: "text-sky-700", soft: "bg-sky-50 border-sky-200 text-sky-800", dot: "bg-sky-500", ring: "ring-sky-300 border-sky-400" },
  remove: { text: "text-rose-700", soft: "bg-rose-50 border-rose-200 text-rose-800", dot: "bg-rose-500", ring: "ring-rose-300 border-rose-400" },
  create_subscription: { text: "text-violet-700", soft: "bg-violet-50 border-violet-200 text-violet-800", dot: "bg-violet-500", ring: "ring-violet-300 border-violet-400" },
  issue: { text: "text-amber-700", soft: "bg-amber-50 border-amber-200 text-amber-800", dot: "bg-amber-500", ring: "ring-amber-300 border-amber-400" },
};

export const APPLY_KINDS = ["add", "move", "remove", "create_subscription"];
export const EMPTY_SEL = { seqs: new Set(), domains: new Set() };
export const isLocked = (r) => !!r.blocked || ["applied", "skipped", "queued"].includes(r.apply?.status);
export const KIND_SHORT = { add: "Add", move: "Move", remove: "Remove", create_subscription: "New subscription" };
export const toggleIn = (set, v) => { const n = new Set(set); if (n.has(v)) n.delete(v); else n.add(v); return n; };

export const fmt = (n) => (n ?? 0).toLocaleString();
export const fmtDate = (iso) => (iso ? new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "");
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

export function describeParams(p = {}) {
  const plats = (p.platforms || []).map((k) => PLATFORM_LABEL[k]).join(", ");
  const scope = [p.territory && `territory ${p.territory}`, p.domain && `domain ${p.domain}`].filter(Boolean).join(" · ") || "everything";
  return `${plats} · ${scope} · ${p.source === "live" ? "live Stax Bill" : "mirror"}`;
}
